import { BsArrowRight } from "react-icons/bs";
import styled from "styled-components";
import { Button } from "components/button";
import { responsive } from "theme/reponsive";

export const SummerWrapper = styled.div`
   background-color: #fafafa;
   margin: 5rem 0;
`;

export const RelatedWrapper = styled.div`
   margin: 5rem 0;
`;

export const RelatedBox = styled.div`
   display: grid;
   grid-template-columns: repeat(4, 30rem);
   grid-column-gap: 3.7rem;

   div.relatedCard {
      margin: 0;
   }
   @media screen and (max-width: 990px) {
      display: block;
      div.relatedCard {
         margin-bottom: 3rem;
      }
   }
`;

export const CustomButton = styled(Button)`
   width: 10.8rem;
   height: 3.6rem;
   font-size: 1.4rem;
`;

export const SummerGridWrapper = styled.div`
   display: flex;
   margin-top: 4.6rem;

   @media screen and (max-width: 990px) {
      flex-direction: column-reverse;
   }
`;

export const SummerGrid = styled.div`
   display: grid;
   grid-template-columns: repeat(4, 1fr);
   gap: 3rem;

   .summer-card {
      min-width: 300px;

      .image-div {
         width: 100%;
         height: 17.7rem;
         position: relative;
         filter: drop-shadow(0px 12px 70px rgba(204, 204, 204, 0.4));
         img {
            border-radius: 10px 10px 0 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
         }
      }
      .content-div {
         padding: 1.6rem 1.5rem 1.6rem;
         background-color: #f7f7f7;
         box-shadow: 0px 12px 70px rgba(204, 204, 204, 0.4);
         height: 21rem;
         display: flex;
         flex-direction: column;
         justify-content: space-between;
         background-color: #fff;

         p {
            font-size: 14px;
            line-height: 18px;
            color: #9d9595;
         }

         p.desc {
            font-weight: 500;
            font-size: 16px;
            line-height: 20px;
            text-transform: uppercase;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
            margin-bottom: 0.5rem;
         }
         p.title {
            text-transform: capitalize;
            font-weight: 500;
            font-size: 16px;
            line-height: 20px;
            color: #444444;
            margin-bottom: 0.5rem;
         }
         p.duration {
            margin-bottom: 0.5rem;
         }
         p.age {
            margin-bottom: 0.5rem;
         }

         .action-div {
            display: flex;
            align-items: center;
            justify-content: space-between;
            /* min-height: 100px; */
         }

         .link {
            cursor: pointer;
            display: flex;
            align-items: center;
            p {
               font-weight: 500;
               font-size: 14px;
               line-height: 18px;
               margin-right: 1.1rem;
               color: ${({ theme }) => theme.colors?.primary};
            }
         }
      }
   }

   @media screen and (max-width: 990px) {
      width: 100%;
      display: block;
      .summer-card {
         margin-bottom: 3rem;
         .content-div {
            height: auto;
            min-height: 21.7rem;
         }
      }
   }

   ${responsive("$xsmall")`
   display: grid;
   grid-template-columns: repeat(1, 1fr);
`}
`;

export const PersonnelSection = styled.div`
   background-color: red;
   height: 200px;
`;

export const Arrow = styled(BsArrowRight)`
   font-size: 25px;
   color: ${({ theme }) => theme.colors?.primary};
`;

export const AdsSection = styled.div`
   max-width: 300px;
   margin-right: 3.2rem;
   @media screen and (max-width: 990px) {
      width: 100%;
      margin: 0;
      max-width: 100%;
   }
`;

export const BannerWrapper = styled.div<{ url: string }>`
   background-image: linear-gradient(#1c1c3910, #0c0c0ca6), url(${({ url }) => url});
   min-height: 200px;
   height: 337px;
   background-position: center;
   background-size: cover;
   background-repeat: no-repeat;
   width: 100%;
   display: flex;
   padding-left: 85px;
   flex-direction: column;
   justify-content: center;
   padding: 2rem;

   h1 {
      font-size: 6rem;
      color: #fff;
      line-height: 89px;
   }

   ${responsive("$small")`
      height: 400px;
   `}

   ${responsive("$xsmall")`
      h1 {
         font-size: 4rem;
         line-height: 3.2rem
      }
`}
`;

export const CtaWrapper = styled.div<{ url: string }>`
   background-image: url(${({ url }) => url});
   min-height: 200px;
   height: 337px;
   background-position: center;
   background-size: cover;
   background-repeat: no-repeat;
   width: 100%;
   display: flex;
   align-items: center;
   padding-left: 5rem;

   h2 {
      font-size: 5rem;
      max-width: 57rem;
      color: #fff;
      line-height: 6.3rem;
   }
   @media screen and (max-width: 990px) {
      height: 250px;
      padding-left: 30px;
      h2 {
         font-size: 3rem;
         line-height: 3.4rem;
         max-width: 30rem;
      }
   }
`;

export const FilterWrapper = styled.div`
   background-color: #fff;
   height: 18.5rem;
   width: 100%;
   padding: 3.1rem 1.3rem 6.1rem 2.4rem;
   p {
      font-size: 18px;
      line-height: 23px;
      color: #333366;
      margin-bottom: 2.4rem;
   }
`;

export const PostWrapper = styled.div`
   margin-top: 4rem;
`;

export const AdvertCard = styled.div`
   border-radius: 10px;
   box-shadow: 0px 4px 70px rgba(204, 204, 204, 0.4);
   background-color: #fff;
   &:not(:last-of-type) {
      margin-bottom: 4.5rem;
   }
   .image-div {
      height: 20rem;
      width: 100%;
      position: relative;
      div {
         width: 100%;
      }
      img {
         border-radius: 10px 10px 0 0;
         height: 18rem;
         width: 100%;
         object-fit: cover;
      }
   }
   .text-div {
      padding: 1.3rem;
      p {
         font-weight: 500;
         font-size: 15px;
         line-height: 23px;
         color: #666666;
      }
   }
`;

export const HorizontalAd = styled.div`
   width: 100%;
   border-radius: 10px;
   box-shadow: 0px 4px 70px rgba(204, 204, 204, 0.4);
   background-color: #fff;
   &:not(:last-of-type) {
      margin-bottom: 4.5rem;
   }
   .image-div {
      height: 20rem;
      width: 100%;
      position: relative;
      div {
         width: 100%;
      }
      img {
         border-radius: 10px 10px 0 0;
         height: 18rem;
         width: 100%;
         object-fit: cover;
      }
   }
   .text-div {
      padding: 1.3rem;
      p {
         font-weight: 500;
         font-size: 15px;
         line-height: 23px;
         color: #666666;
      }
   }
`;

export const SingleSummerWrapper = styled.div`
   padding: 4.5rem 7rem 8rem 7rem;
   background-color: #fafafa;
   @media screen and (max-width: 990px) {
      padding: 2rem 3rem 5rem;
   }
`;

export const MainDescription = styled.div`
   width: 70%;
   color: #666;
   padding: 2rem;
   .desc {
      padding: 3rem;
      background: #fff;
      box-shadow: 0px 4px 70px rgba(204, 204, 204, 0.4);
      border-radius: 10px;
      word-break: break-all;
      h4,
      p:not(:last-of-type) {
         margin-bottom: 10px;
      }
      .apply-btn {
         margin-top: 1rem;
      }
   }
   img {
      height: 50rem;
      width: 100%;
      margin-bottom: 2.4rem;
      background-size: cover;
      border-radius: 10px;
   }
   .activities-section {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      align-items: center;
   }
   .activities {
      padding: 4px 8px;
      background: #eef4ff;
      color: #3578e5;
      border: 1px solid #3578e5;
      font-size: 16px;
      font-weight: 400;
      border-radius: 12px;
      text-transform: capitalize;
   }
   @media screen and (max-width: 990px) {
      padding: 0.2rem;
      width: 100%;
      img {
         height: 20rem;
         width: 100%;
      }
      .desc {
         padding: 1rem;
      }
   }
`;

export const DivideSection = styled.div`
   width: 100%;
   display: flex;
   gap: 20px;
   @media screen and (max-width: 768px) {
      flex-direction: column;
   }
`;

export const Container = styled.div`
   max-width: 1440px;
   margin: 0 auto;
`;

export const SummerPreviewWrapper = styled.div`
   .summer-card {
      margin-top: 100px;
      min-height: 394px;
      width: 320px;
      margin: auto;

      .image-div {
         height: 17.7rem;
         position: relative;
         filter: drop-shadow(0px 12px 70px rgba(204, 204, 204, 0.4));
         img {
            border-radius: 10px 10px 0 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
         }
      }
      .content-div {
         padding: 2.8rem 2.1rem 1.6rem;
         background-color: #f7f7f7;
         box-shadow: 0px 12px 70px rgba(204, 204, 204, 0.4);
         height: 24rem;
         display: flex;
         flex-direction: column;
         justify-content: space-between;
         p {
            font-size: 14px;
            line-height: 18px;
            color: #9d9595;
         }
         p.desc {
            font-weight: 400;
            font-size: 16px;
            line-height: 20px;
            text-transform: uppercase;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
            margin-bottom: 1.5rem;
         }
         p.title {
            text-transform: capitalize;
            font-weight: 500;
            font-size: 16px;
            line-height: 20px;
            color: #444444;
            margin-bottom: 1.2rem;
         }
         p.duration {
            margin-bottom: 1.5rem;
         }
         p.age {
            margin-bottom: 1.9rem;
         }

         .action-div {
            display: flex;
            align-items: center;
            justify-content: space-between;
         }

         .link {
            cursor: pointer;
            display: flex;
            align-items: center;
            p {
               font-weight: 500;
               font-size: 14px;
               line-height: 18px;
               margin-right: 1.1rem;
               color: ${({ theme }) => theme.colors?.primary};
            }
         }
      }
   }

   @media screen and (max-width: 990px) {
      width: 100%;
      display: block;
      .summer-card {
         margin-bottom: 3rem;
         .content-div {
            height: auto;
            min-height: 21.7rem;
         }
      }
   }
`;

export const AdWrapper = styled.div`
   width: 30%;
   @media screen and (max-width: 990px) {
      width: 100%;
   }
`;

export const EmptyStateWrapper = styled.div`
   width: 100%;
   margin: 50px 0;
   display: flex;
   justify-content: center;
   align-items: center;

   p.search-title {
      font-weight: 700;
      font-size: 24px;
      line-height: 30px;
      color: #444444;
      margin: 30px 0 7px;
      text-align: center;
   }

   p.description {
      font-size: 14px;
      line-height: 18px;
      text-align: center;
      color: #999999;
   }
`;

export const AutocompleteDiv = styled.div`
   position: relative;
   .empty-state {
      font-size: 12px;
      text-align: center;
   }
   .search-result {
      position: absolute;
      top: 85px;
      max-height: 172px;
      overflow-y: scroll;
      width: 280px;
      z-index: 200;
      background-color: #fff;
      border-radius: 8px;
      min-height: 4.8rem;
      padding-top: 5px;
      .result {
         padding-left: 10px;
         height: 40px;
         display: flex;
         align-items: center;
         padding-right: 5px;
         &:hover {
            background: rgba(0, 126, 255, 0.08);
         }
         p {
            color: #000;
            font-size: 15px;
            cursor: pointer;
            font-weight: 400;
         }
      }
   }
`;
